import { faPeopleArrowsLeftRight } from "@fortawesome/free-solid-svg-icons"
import Ajv from "ajv"
const ajv = new Ajv() // options can be passed, e.g. {allErrors: true}

const schema = {
  type: "object",
  properties: {
    name: {
      type: "string",
      title: "string"
    },
    bar: {type: "string"},
  },
  required: ["name.type"],
  additionalProperties: false,
}

const validate = ajv.compile(schema)

export default defineNuxtPlugin(() => {
  return {
    provide: {
      validate: async (jsonText: string) => {
        try {
          const parsedJson = JSON.parse(jsonText)
          return {
            success: true
          }
          // const valid = validate(parsedJson)
          // if(!valid) return validate
          // else return valid
        } catch (err: any) {
          return {success: false, error: err.toString()}
        }
      }
    }
  }
})